<template>
  <div>
    <van-nav-bar :title="$t('LastTranslate.registrationAgreement')" />
    <div class="main" v-html="chContent">
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
export default {
  data () {
    return {
      type: 3,
      chContent: '',
    }
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  mounted () {
      /**
     * 分享链接
     * http://m-jingyi.lexintech.com/#/registerText?language=2&sourceType=1&type=3
     */
    if (this.$route.query.language) {
      const language = this.$route.query.language || "0"; //0:中文 1:英文 2:繁体
      const SourceType = this.$route.query.sourceType || "0"; //0:国内 1:海外
      const type = this.$route.query.type || 3;
      this.$store.commit("SourceType", SourceType);
      // 设置语言类型
      this.$store.dispatch("AcceptLanguage", language).then(async () => {
        let lang =
          language == 0
            ? "zh-CN"
            : language == 1
            ? "en"
            : language == 2
            ? "zh-TW"
            : "";
        this.$store.commit("setLang", lang);
        this.$i18n.locale = lang;
        // await this.$store.dispatch('SourceType',SourceType);
        await this.getTextData();
      });
    }
  },
  methods: {
    getTextData() {
      this.$commonPromise("get", '/api/member/ContentManage/contentManage', {type: 3}).then(res => {
        if(res.code === 200) {
          this.chContent = res.data.chContent;
        }else {
          this.$toast(res.msg);
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  padding: 20px;
  line-height: 1.8;
}
</style>